import { render, staticRenderFns } from "./LogErrorDeatil.vue?vue&type=template&id=4678d7ff"
import script from "./LogErrorDeatil.vue?vue&type=script&lang=js"
export * from "./LogErrorDeatil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports